export default __webpack_public_path__ + "static/media/hoitokeskustelu.9fb55cde.svg";